@if (!!options) {
<div>
  <header class="ddd-dialog-header">
    <title class="dialog-title">{{ options.title }}</title>
    <div class="ddd-icon close-primary" (click)="close()"></div>
  </header>
  <div class="ddd-dialog-main">
    @if (options.type === 'TEXT') {
    <div class="section-text" [innerHtml]="options.content"></div>
    } @if (options.type === 'LIST') {
    <div class="section-list">
      <ul>
        @for (element of options.content; track element) {
        <li [innerHtml]="element"></li>
        }
      </ul>
    </div>
    } @if (options.type === 'GRID') {
    <div class="section-grid">
      <table>
        <tbody>
          @for (row of grid; track row) {
          <tr class="section-grid__row">
            @for (col of row; track col) {
            <td class="section-grid__col" [style.flex]="col.flex">
              <div>
                <span [innerHtml]="col.content"></span>
              </div>
            </td>
            }
          </tr>
          }
        </tbody>
      </table>
    </div>
    }
  </div>
  @if (!!options.buttonText) {
  <footer class="ddd-dialog-footer">
    <button class="ddd-button primary" tabindex="-1" autofocus="false" (click)="close()">
      {{ options.buttonText }}
    </button>
  </footer>
  }
</div>
}
